/** Platform icon paths — shared with KPI expanded cards (KpiHoverLayer). */
export const DASHBOARD_PLATFORM_ICON_PATHS = {
  instagram: '/assets/images/instagram.svg',
  facebook: '/assets/images/facebook.svg',
  linkedin: '/assets/images/linkedin.svg',
  twitter: '/assets/images/x_1.svg',
  tiktok: '/assets/images/tiktok.svg',
}

export const DASHBOARD_PLATFORM_LABELS = {
  instagram: 'Instagram',
  facebook: 'Facebook',
  linkedin: 'LinkedIn',
  twitter: 'X',
  tiktok: 'TikTok',
}

export function getDashboardPlatformIcon(platformId) {
  if (!platformId) return null
  return DASHBOARD_PLATFORM_ICON_PATHS[platformId] || null
}

export function getDashboardPlatformLabel(platformId, platformLabels = {}) {
  if (!platformId) return ''
  return platformLabels[platformId] || DASHBOARD_PLATFORM_LABELS[platformId] || platformId
}
